<template>
  <div>
    <div class="card__header">
      <p class="card__title">Thank you!</p>
      <div class="card__subtitle">
        <p class="body gutter">You will receive a confirmation email shortly.</p>
        <p v-if="$parent.isGift" class="body">If you want you can update the order until 10am the day before delivery.</p>
        <p v-else class="body">Please tell us if and how you want to be notified about your order. You can change that anytime in your account settings.</p>
      </div>
    </div>
    <div v-if="!$parent.isGift" class="card__content">
      <div class="form">
        <div class="form__field">
          <p class="form__label body">Order delivered</p>
          <p class="form__notice">To notify you when your order has arrived</p>
          <div class="form__control radio radio--landscape">
            <div class="radio__item">
              <input type="radio" name="notification_orders_delivered" class="radio__control"
              id="notification_orders_delivered_sms" 
              data-column="orders_delivered_sms"
              v-model="notifications.orders_delivered_sms" 
              v-on:change="setValue($event, 1)"
              value="1">
              <label for="notification_orders_delivered_sms" class="radio__label">SMS</label>
            </div>
            <div class="radio__item">
              <input type="radio" name="notification_orders_delivered" class="radio__control"
              id="notification_orders_delivered_email"
              data-column="orders_delivered_email" 
              v-model="notifications.orders_delivered_email"
              v-on:change="setValue($event, 1)"
              value="1">
              <label for="notification_orders_delivered_email" class="radio__label">Email</label>
            </div>
          </div>
        </div>
        <div class="form__field">
          <p class="form__label body">Delivery updates</p>
          <p class="form__notice">In case we need to contact you regarding your order</p>
          <div class="form__control radio radio--landscape">
            <div class="radio__item">
              <input type="radio" name="notification_orders_not_delivered" class="radio__control"
              id="notification_orders_not_delivered_sms"
              data-column="orders_not_delivered_sms" 
              v-model="notifications.orders_not_delivered_sms"
              v-on:change="setValue($event, 1)" 
              value="1">
              <label for="notification_orders_not_delivered_sms" class="radio__label">SMS</label>
            </div>
            <div class="radio__item">
              <input type="radio" name="notification_orders_not_delivered" class="radio__control"
              id="notification_orders_not_delivered_email" 
              data-column="orders_not_delivered_email"
              v-model="notifications.orders_not_delivered_email" 
              v-on:change="setValue($event, 1)" 
              value="1">
              <label for="notification_orders_not_delivered_email" class="radio__label">Email</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card__actions">
      <button type="submit" class="button button--md button--secondary" v-on:click="valid()">Back to dashboard</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notifications: this.$root.notifications
    }
  },

  beforeMount() {
  },

  mounted() {
  },

  methods: {
    valid() {
      window.location.reload();
    },

    setValue: function (event, isRadio = false) {
      var $el = $(event.target);

      axios.post("/account/notifications", {
        column: $el.attr('data-column'),
        value: isRadio ? parseInt($el.val()) : $el.is(':checked')
      }).then(res => {
        if (res.success === false) {

        } else {
          this.notifications = res.data;
        }
      }).catch(error => console.log(error));
    }
  }
}
</script>
